import { z } from 'zod';

export const editNotesSchema = z
  .string()
  .min(1, 'Notes is required')
  .max(500, 'Notes is too long! Please make it less then 500 characters');

export const reasonSchema = z
  .string()
  .min(1, 'Reason is required')
  .max(500, 'Reason is too long! Please make it less than 500 characters');
